export default {
  title: 'Panneau d\'administration',
  subtitle: 'Gérer les options d\'administration',
  user_management: 'Gestion des utilisateurs',
  user_management_desc: 'Gérer les utilisateurs et se faire passer pour eux pour dépannage.',

  // Impersonation
  impersonation: {
    banner: {
      title: 'Impersonation: {{userName}}',
      subtitle: 'Vous agissez actuellement en tant que cet utilisateur',
      end_button: 'Terminer l\'impersonation'
    },
    button: {
      impersonate: 'Se faire passer pour',
      you: 'Vous',
      tooltip_self: 'Impossible de se faire passer pour soi-même',
      tooltip_impersonate: 'Se faire passer pour {{userName}}'
    },
    confirm: {
      title: 'Confirmer l\'impersonation',
      message: 'Êtes-vous sûr de vouloir vous faire passer pour {{userName}}?\n\nCela basculera temporairement votre session pour agir en tant que cet utilisateur.'
    },
    messages: {
      started: 'Impersonation démarrée avec succès',
      ended: 'Impersonation terminée avec succès',
      start_failed: 'Échec du démarrage de l\'impersonation',
      end_failed: 'Échec de la fin de l\'impersonation'
    }
  },

  // User management
  users: {
    name: 'Nom d\'affichage',
    email: 'Email',
    role: 'Rôle',
    status: 'Statut',
    created_at: 'Créé le',
    active: 'Actif',
    inactive: 'Inactif',
    search_placeholder: 'Rechercher des utilisateurs...',
    no_users: 'Aucun utilisateur trouvé',
    load_failed: 'Échec du chargement des utilisateurs',
    edit_user: 'Modifier l\'utilisateur',
    editTitle: 'Modifier l\'utilisateur',
    editSubtitle: 'Modifier les paramètres et permissions de l\'utilisateur',
    basic_info: 'Informations de base',
    is_active: 'Utilisateur actif'
  },

  // Roles
  roles: {
    user: 'Utilisateur',
    admin: 'Administrateur',
    super_admin: 'Super Administrateur'
  },

  // Permissions
  permissions: {
    title: 'Permissions',
    add: 'Ajouter une permission',
    grant: 'Accorder la permission',
    revoke: 'Révoquer la permission',
    type: 'Type de permission',
    target_location: 'Lieu cible',
    target_user: 'Utilisateur cible',
    notes: 'Notes',
    select_type: 'Sélectionner le type de permission',
    all_locations: 'Tous les lieux',
    all_users: 'Tous les utilisateurs',
    granted: 'Permission accordée avec succès',
    revoked: 'Permission révoquée avec succès',
    grant_failed: 'Échec de l\'octroi de la permission',
    revoke_failed: 'Échec de la révocation de la permission'
  }
};
